module.exports = __webpack_public_path__ + "img/fengjing.19bb5d88.jpg";